// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/arrow-up.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/arrow-up'

import { Icon, type IconComponentProps } from '../icon'

export const ArrowUpIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
